import React  from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PhoneIcon from '@mui/icons-material/Phone';
import Typography from '@mui/material/Typography';
import CustomTestField from "../Components/CustomTextField";
import Button from '@mui/material/Button';



const ContactUsBlock = () => {



    return (
        <div className="App-header">
                
                    <div style={{ width: '80%', justifyContent: 'space-evenly', flexDirection: 'column', alignItems: 'center', height: '500px', display: 'flex' }}>
                       
                        
                        {/* Logo and Heading */}

                        <div style={{ width: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', display: 'flex', color: '#10406B' }}>
                            <Typography variant="h5" component="h1" sx={{
                                color:'#10406B',
                                fontFamily:"'Tajawal', sans-serif",
                                fontStyle:'bold'
                            }} >
                                تواصل معنا
                            </Typography>
                            <Typography paragraph={true} component="p" sx={{
                                color:'#10406B',
                                fontFamily:"'Tajawal', sans-serif",
                                fontStyle:'normal',
                                marginTop:'10px',
                                textAlign: 'center'
                            }} >
                                يرجى ملئ النموذج ادناه للتواصل معنا وسيتم الرد في اقرب وقت ممكن
                            </Typography>
                            
                        </div>

                        <div style={{ width: '100%', justifyContent: 'space-between', flexDirection: 'row', display: 'flex' }}>
                            <div
                                className="contact-us-card-one"
                            >
                                <CustomTestField label={"الاسم"} icon={<PersonOutlineIcon color={"#707070"} />}/>
                                
                            </div>
                            
                            <div
                                className="contact-us-card-one"
                            >
                                <CustomTestField label={"رقم الاتصال"} icon={<PhoneIcon color={"#707070"} />}/>
                            </div>
                            <div
                                className="contact-us-card-one"
                            >
                              <CustomTestField label={"جهة الاتصال"} icon={<KeyboardArrowDownIcon color={"#707070"} />}/>
                            </div>
                        </div>

                        <div style={{ width: '100%',alignItems: 'flex-start', justifyContent: 'space-between', flexDirection: 'row', display: 'flex' }}>
                            <div
                                className="contact-us-card-two"
                            >
                                <CustomTestField label={"نص الرسالة..."} multiline={true} icon={null}/>
                                
                            </div>
                            
                            
                            <div
                                className="contact-us-email-phone-container"
                                style={{
                                    height:"100%",
                                }}
                            >
                                <div style={{ width: '100%',height:"100%",alignItems: 'flex-start', justifyContent: 'space-between', flexDirection: 'column', display: 'flex' }}>
                                    <div style={{
                                            width: '100%',justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row', display: 'flex', paddingTop:'10px',paddingBottom:'10px'
                                            }}>
                                        
                                            
                                            <div className="contact-us-email-phone-content">
                                                <Typography variant="h6" sx={{fontSize:14}} component="h1" >
                                                +964 770 0000 000
                                                </Typography>
                                                <Typography variant="h6"sx={{fontSize:14}} component="h1" >
                                                +964 770 0000 000
                                                </Typography>
                                            </div>
                                            <div className="contact-us-email-phone-title">

                                                <img
                                                    src={`${require('../../../assets/imgs/phone.png')}`}
                                                    alt={"شركة السلام العامة"}
                                                    loading="lazy"
                                                    width={"40px"}
                                                    
                                                />
                                            </div>
                                            
                                        </div>
                                        <div style={{
                                            width: '100%',justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row', display: 'flex', paddingTop:'10px',paddingBottom:'10px'
                                            }}>
                                        
                                            <div className="contact-us-email-phone-content">
                                                <Typography variant="h6" sx={{fontSize:14}} component="h1" >
                                                    contact@alsalam.gov.iq
                                                </Typography>
                                                <Typography variant="h6" sx={{fontSize:14}} component="h1" >
                                                    support@alsalam.gov.iq
                                                </Typography>
                                            </div>
                                            <div className="contact-us-email-phone-title">
                                            <img
                                                src={`${require('../../../assets/imgs/email.png')}`}
                                                alt={"شركة السلام العامة"}
                                                loading="lazy"
                                                width={"40px"}
                                            />
                                            </div>
                                        </div>
                                </div>
                              
                            </div>
                        </div>

                        <Button variant="contained" 
                        sx={{
                            fontFamily: " 'Tajawal', sans-serif",
                            backgroundColor: '#15558D',
                            color: '#fff',
                            fontSize: '16px',
                            marginLeft:'8px',
                            borderRadius: '14px'
                            }}>
                            أرسال الرسالة
                        </Button>
                        
                    </div>
                </div>
            
    )
}


export default ContactUsBlock;